import axios from "axios"
import { agentVerifyURL, apiURL, prsCodes } from '../utils'

class CustomError extends Error {
  constructor(message, title, code) {
    super(message)
    this.msgText = message
    this.msgTitle = title
    this.msgCode = code
  }
}

const parseRespone = (res) => {
  if (!!res.responsePayload) return res.responsePayload
  return res
}

export const login = async (payload) => {
  payload['prsCode'] = prsCodes.login
  const { data: res } = await axios.post(`${apiURL}`, payload)
  const resData = parseRespone(res)
  console.log({ resData })
  if (resData.statusCode !== 200) throw new CustomError(resData.msgText, resData.msgTitle, resData.msgCode)

  if (resData.productId === null || `${resData.productId}` !== payload.productId) {
    throw new CustomError('Agent access is forbidden', 'Access Denied', '403')
  }

  return resData
}

export const getUserPersona = async (email) => {
  if (!email) return null
  console.log({ email })
  const payload = {
    login: email,
    prsCode: '3702R702',
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  return parseRespone(res)
}

export const generateVerificationCode = async (payload) => {
  payload = {
    ...payload,
    prsCode: '3702F702',
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  const result = parseRespone(res)
  if (result.statusCode !== 200)
    throw new CustomError(result.msgText, result.msgTitle || 'Could not send verification email', result.msgCode)
  return result
}

export const verifyEmail = async (payload) => {
  payload = {
    ...payload,
    prsCode: '3702F702',
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  const result = parseRespone(res)
  if (result.msgCode === '201') {
    throw new CustomError(result.msgText, result.msgTitle || 'Could not verify email', result.msgCode)
  }
  return result
}

export const verifyAgent = async (payload) => {
  payload = {
    ...payload,
    prsCode: '3702702I',
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  const response = parseRespone(res)
  console.log({ response })
  if (response?.statusCode !== 200)
    throw new CustomError(
      response?.message,
      response?.statusCode === 400 ? response?.message || 'Invalid Producer ID' : 'Internal Server Error',
      response?.statusCode
    )
  return response?.response.length ? response?.response[0] : response?.response
}

export const getApps = async ({ queryKey }) => {
  let payload = {
    ...queryKey[1],
    prsCode: '3702702J',
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  return parseRespone(res)
}

export const getMetrics = async ({ queryKey }) => {
  let payload = {
    ...queryKey[1],
    prsCode: prsCodes.getMetricsV2,
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  return parseRespone(res)
}

export const getFactTableApps = async ({ queryKey }) => {
  let payload = {
    ...queryKey[1],
    prsCode: prsCodes.getFactTableApps,
  }
  const { status, data: res } = await axios.post(`${apiURL}`, payload)
  const result = parseRespone(res)
  if (status !== 200 || !Array.isArray(result.fact_table_applications)) {
    throw new Error(res.msgText || 'Failed to call getFactTableApps API')
  }
  return result
}

export const getFactTableAppsV2 = async ({ queryKey }) => {
  let payload = {
    ...queryKey[1],
    prsCode: prsCodes.getFactTableAppsV2,
  }
  const { status, data: res } = await axios.post(`${apiURL}`, payload)
  const result = parseRespone(res)
  if (status !== 200 || !Array.isArray(result.fact_table_applications)) {
    throw new Error(res.msgText || 'Failed to call getFactTableApps API')
  }
  return result
}

export const getAgentProducts = async ({ queryKey }) => {
  let payload = {
    ...queryKey[1],
    prsCode: prsCodes.getAgentProducts,
  }
  const { status, data: res } = await axios.post(`${apiURL}`, payload)
  const result = parseRespone(res)
  if (status !== 200 || !Array.isArray(result)) {
    throw new Error(res.message || 'Failed to call getAgentProducts API')
  }
  return result
}

export const req90DaysChange = async (payload) => {
  payload = {
    ...payload,
    prsCode: prsCodes.req90DaysChange,
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  const result = parseRespone(res)
  if (result.message) throw new Error(result.message || 'Failed to call req90DaysChange API')
  return result
}

export const createAffiliateCode = async (payload) => {
  const { data: res } = await axios.post(`${apiURL}`, {
    ...payload,
    prsCode: window.location.href.includes('demo') ? '3702702Y' : prsCodes.createAffiliateCode,
  })
  if (parseRespone(res).statusCode !== '200')
    throw new CustomError(
      parseRespone(res).msgText || 'Failed to call createAffiliateCode API',
      'Could not create affiliate code',
      500
    )
  return parseRespone(res)
}

export const createAccount = async (payload) => {
  payload = {
    ...payload,
    prsCode: prsCodes.createAccount,
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  const responsePayload = parseRespone(res)
  if (responsePayload.statusCode === 201)
    throw new CustomError(
      `${responsePayload.msgText.substring(0, responsePayload.msgText.length - 1)}, please contact support.`,
      'Could not create account',
      500
    )

  return responsePayload
}

export const createAccountV3 = async (payload) => {
  payload = {
    ...payload,
    prsCode: prsCodes.createAccountV3,
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  const responsePayload = parseRespone(res)
  if (
    responsePayload.statusCode === '201' ||
    responsePayload.statusCode === 201 ||
    responsePayload.statusCode === '205' ||
    responsePayload.statusCode === 205
  )
    throw new CustomError(
      responsePayload.msgText
        ? `${responsePayload.msgText.substring(0, responsePayload.msgText.length)}, please contact support.`
        : 'Something went wrong!',
      'Could not create account',
      500
    )

  return responsePayload
}

export const getAppsV3 = async ({ queryKey }) => {
  console.log({ queryKey })
  let payload = {
    ...queryKey[1],
    prsCode: prsCodes.getAppsV3,
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  return parseRespone(res)
}

export const agentVerify = async (payload) => {
  const { data: res } = await axios.post(`${apiURL}`, { ...payload, prsCode: prsCodes.agentVerifyV3 })
  const responsePayload = parseRespone(res)

  if (responsePayload.statusCode && responsePayload.statusCode !== 200)
    throw new CustomError(`${responsePayload.message || responsePayload.msgText}`, 'Could not validate agent', 400)
  return responsePayload
}

export const getProducerProfile = async ({ queryKey }) => {
  const { data: res } = await axios.post(`${apiURL}`, { ...queryKey[1], prsCode: prsCodes.getProducerProfile })
  const responsePayload = parseRespone(res)

  if (responsePayload.statusCode && responsePayload.statusCode !== 200)
    throw new CustomError(
      `${responsePayload.message || responsePayload.msgText}`,
      'Could not get producer profile',
      400
    )
  return responsePayload
}

export const getMetricsV3 = async ({ queryKey }) => {
  let payload = {
    ...queryKey[1],
    prsCode: prsCodes.getMetricsV3,
  }
  const { data: res } = await axios.post(`${apiURL}`, payload)
  return parseRespone(res)
} 

export const getAgentCommissions = async ({ queryKey }) => {
  const { data: res } = await axios.post(`${apiURL}`, { ...queryKey[1], prsCode: prsCodes.getAgentCommissions })
  const responsePayload = parseRespone(res)

  if (responsePayload.message || (responsePayload.statusCode && responsePayload.statusCode !== 200))
    throw new CustomError(
      `${responsePayload.message || responsePayload.msgText}`,
      'Could not get agent commissions',
      400
    )
  return responsePayload
}